<template>
    <div v-if="monster">
        <div class="hero hero-sm bg-dark">
            <div class="hero-body container grid-xl">
                <div>
                    <div class="popover popover-bottom">
                        <figure class="d-inline-block avatar avatar-xl mr-2" style="margin-bottom: 18px">
                            <img :src="image" alt="...">
                        </figure>
                        <h1 class="d-inline-block pl-2 mt-2">{{monster.name}}</h1>
                        <div class="popover-container">
                            <div class="card pb-2 px-2">
                                <div class="card-header text-dark">
                                    <select v-model="location" class="mb-1 form-select select-sm text-dark">
                                        <option v-for="opt in options" :value="opt">{{opt}}</option>
                                    </select>
                                    <button class="btn btn-primary " @click="add">Add</button> to the current game?</div>
                            </div>
                        </div>
                    </div>
                    <h3 class="d-inline-block pl-2 mt-2 text-gray">[{{monster.type}}]</h3>
                </div>
                <p>{{monster.size}} · {{monster.alignment}} · {{monster.languages}} · {{monster.senses}}</p>
            </div>
        </div>
        <header class="bg-primary py-1">
            <section class="container pt-2 grid-xl">
                <Stat :value="monster.dexterity">Dexterity </Stat>
                <Stat :value="monster.wisdom">Wisdom </Stat>
                <Stat :value="monster.strength">Strength </Stat>
                <Stat :value="monster.intelligence">Intelligence </Stat>
                <Stat :value="monster.perception">Perception </Stat>
            </section>
        </header>
        <header class="bg-gray py-1">
            <section class="container pt-2 grid-xl">
                <Stat :value="monster.challenge_rating">Challenge Rating </Stat>
                <Stat :value="monster.armor_class">Armor Class </Stat>
                <Stat :value="monster.hit_points">Hit Points </Stat>
            </section>
        </header>
        <div class="container grid-xl mt-2 py-2 px-2">
            <MoveList :list="monster.actions">Actions</MoveList>
            <MoveList :list="monster.legendary_actions">Legendary Actions</MoveList>
            <MoveList :list="monster.special_abilities">Special Abilities</MoveList>
            <pre class="code" v-if="raw">
<code>{{JSON.stringify(monster, null, 2)}}</code>
</pre>
            <button class="btn btn-primary" @click="raw = !raw">Toggle Raw Data</button>
        </div>
    </div>
</template>
<script>
export default {
    created: function() {
        this.db.collection("monsters").doc(this.$route.params.id).get().then((doc) => {
            this.monster = doc.data();
            this.storage.child(this.monster.img).getDownloadURL().then((url) => {
                this.image = url
            })
        })
        this.rdb.ref("campaigns/ieSevBpTzJys28ySOVnj/spawnPositions").on('value', (snapshot) => {
            this.options = snapshot.val();
        });
    },
    data() {
        return {
            monster: null,
            image: null,
            raw: false,
            options: null,
            location: null
        }
    },
    methods: {
        add() {
            this.rdb.ref("campaigns/ieSevBpTzJys28ySOVnj/spawnMonster").push({id: [this.$route.params.id], pos: [this.location]})
            alert("Added " + this.$route.params.id)
        }
    }
}
</script>